<template>
  <div class="header">
    <div class="profile-section">
      {{ certification?.borrowers?.borrower?.fullName || "" }}
    </div>
    <div class="summary-section summary">
      <div class="summary-group">
        <div
          v-for="(item, index) in summaryLeft"
          :key="index"
          class="summary-item"
          :name="item.name"
        >
          <h3 class="label">{{ item.label }}</h3>
          <p class="value">{{ item.value }}</p>
        </div>
      </div>

      <div class="divider"></div>
      <div class="summary-group">
        <div
          v-for="(item, index) in summaryRight"
          :key="index"
          class="summary-item"
          :name="item.name"
        >
          <h3 class="label">{{ item.label }}</h3>
          <p class="value">{{ item.value }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="details-wrapper">
    <button @click="toggleDetails" class="toggle-button">
      <span
        :class="
          detailsVisible
            ? 'arrow-up icon-up-open-big'
            : 'arrow-down icon-down-open-big'
        "
      ></span>
    </button>
    <SlideTransition :is-visible="detailsVisible">
      <Details :certification="certification" />
    </SlideTransition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { CertificationVM } from "@/types/certifications";
import SlideTransition from "@/components/shared/SlideTransition.vue";
import Details from "@/components/v2/certifications/Details.vue";

const props = defineProps<{
  certification: CertificationVM;
}>();

const detailsVisible = ref<boolean>(false);

const summaryLeft = computed(() => {
  return [
    {
      name: "lender",
      label: "Lender",
      value: props.certification?.header.lenderName ?? "",
    },
    {
      name: "ncherId",
      label: "NCHER ID",
      value: props.certification?.header?.ncherCode,
    },
    {
      name: "programNameAbbr",
      label: "Program",
      value: props.certification?.header?.programName,
    },
    {
      name: "programAltCode",
      label: "ALT Code",
      value: props.certification?.header?.programAltCode,
    },
  ];
});

const summaryRight = computed(() => {
  return [
    {
      name: "loanAmount",
      label: "Loan Amount",
      value: props.certification?.header?.loanAmountDisplay,
    },
    {
      name: "totalDisbursedAmount",
      label: "Total Disb. Amount",
      value: props.certification?.header?.totalDisbursedAmountDisplay,
      title: "Total Disbursed Amount",
    },
  ];
});

function toggleDetails() {
  detailsVisible.value = !detailsVisible.value;
}
</script>

<style scoped>
.header {
  background-color: #e2e4e9;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px #ccc;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 13px;
  margin-bottom: 0;
}

.profile-section {
  color: #000;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 13px;
}

.summary {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  background-color: #e2e4e9;
  margin-bottom: 16px;
  width: 100%;
  position: relative;
}

.summary .summary-group {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.summary-item p {
  margin: 0;
}

.summary-item .label {
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.summary-item .value {
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

.divider {
  width: 0.768px;
  height: 52px;
  transform: rotate(180deg);
  background: #000;
}

.details-wrapper {
  position: relative;
}

.toggle-button {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background-color: black;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -16px;
  left: 50%;
  font-weight: bold;
  z-index: 1;
}

.icon- .arrow-down::before,
.icon- .arrow-up::before {
  content: "";
  display: inline-block;
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 3px;
  transition: transform 0.3s ease;
  color: #fff;
}

@media (max-width: 1200px) {
  .summary .summary-group:first-of-type,
  .summary-section .summary-group:first-of-type {
    max-width: 50%;
  }
}

@media (max-width: 992px) {
	.divider {
		display: none;
	}
  .summary .summary-group:first-of-type,
  .summary-section .summary-group:first-of-type {
    max-width: 100%;
  }
}
</style>
